/**
 * Page Tree Storage Service
 * Phase 2: Page Tree Integration + Unified State Model
 * 
 * Handles persistence of page tree structure to localStorage.
 */

const STORAGE_KEY = 'freshcards:pages';
const CURRENT_PAGE_KEY = 'freshcards:currentPageId';

/**
 * Save pages to storage
 */
export function savePages(pages: Array<{
  id: string;
  title: string;
  parentId?: string;
  type?: string;
}>): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(pages));
  } catch (error) {
    console.error('[PageTreeStorage] Failed to save pages:', error);
  }
}

/**
 * Load pages from storage
 */
export function loadPages(): Array<{
  id: string;
  title: string;
  parentId?: string;
  type?: string;
}> {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    if (data) {
      return JSON.parse(data);
    }
  } catch (error) {
    console.error('[PageTreeStorage] Failed to load pages:', error);
  }
  return [];
}

/**
 * Save current page ID to storage
 */
export function saveCurrentPageId(pageId: string | null): void {
  try {
    if (pageId) {
      console.log('[Storage] Saving currentPageId:', pageId);
      localStorage.setItem(CURRENT_PAGE_KEY, pageId);
    } else {
      console.log('[Storage] Clearing currentPageId');
      localStorage.removeItem(CURRENT_PAGE_KEY);
    }
  } catch (error) {
    console.error('[PageTreeStorage] Failed to save current page:', error);
  }
}

/**
 * Load current page ID from storage
 */
export function loadCurrentPageId(): string | null {
  try {
    const result = localStorage.getItem(CURRENT_PAGE_KEY);
    console.log('[Storage] Loading currentPageId:', result);
    return result;
  } catch (error) {
    console.error('[PageTreeStorage] Failed to load current page:', error);
    return null;
  }
}

/**
 * Clear all stored pages
 */
export function clearPages(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(CURRENT_PAGE_KEY);
  } catch (error) {
    console.error('[PageTreeStorage] Failed to clear pages:', error);
  }
}

/**
 * Check if storage has pages
 */
export function hasStoredPages(): boolean {
  return localStorage.getItem(STORAGE_KEY) !== null;
}

export default {
  savePages,
  loadPages,
  saveCurrentPageId,
  loadCurrentPageId,
  clearPages,
  hasStoredPages
};